import { useEffect } from 'react';
import { useStickyNoteStore } from '@/shared/stores/sticky-note-store';
import { STICKY_NOTE_DEFAULT_SIZE } from '../lib/sticky-note-constants';

/**
 * 付箋追加モードのカスタムフック
 * isAddMode中はカーソルがcrosshairに変わり、画面クリックで付箋を配置する
 * Escキーでキャンセル
 */
export const useAddStickyNoteMode = () => {
  const isAddMode = useStickyNoteStore((s) => s.isAddMode);
  const setAddMode = useStickyNoteStore((s) => s.setAddMode);
  const addNote = useStickyNoteStore((s) => s.addNote);

  useEffect(() => {
    if (!isAddMode) return;
    document.body.style.cursor = 'crosshair';

    const handleClick = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      addNote({
        x: e.clientX,
        y: e.clientY,
        width: STICKY_NOTE_DEFAULT_SIZE.width,
        height: STICKY_NOTE_DEFAULT_SIZE.height,
        scrollX: window.scrollX,
        scrollY: window.scrollY,
        url: window.location.pathname,
        content: '',
      });
      setAddMode(false);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setAddMode(false);
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.cursor = '';
      document.removeEventListener('click', handleClick, { capture: true });
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isAddMode, addNote, setAddMode]);
};
